import { useState, useEffect, useCallback } from 'react';
import { parseJwtToken } from '../utils/commonFunctions';

export function useSuperAdminCheck() {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const fetchPaymentInfo = useCallback(async () => {
    try {
      const storedCreds = localStorage.getItem('login_credentials');

      if (!storedCreds) {
        setIsSuperAdmin(false);
        return;
      }

      const { data: creds } = JSON.parse(storedCreds) || {};

      if (!creds) {
        setIsSuperAdmin(false);
        return;
      }

      const tokenResp = await parseJwtToken(creds);

      const isAdmin =
        tokenResp?.userType === 'superAdmin' ||
        tokenResp?.userRole === 'superAdmin-role';

      setIsSuperAdmin(isAdmin);
    } catch (err) {
      console.error('Error checking super admin:', err);
      setIsSuperAdmin(false);
    }
  }, []);

  useEffect(() => {
    fetchPaymentInfo();
  }, [fetchPaymentInfo]);

  return {
    isSuperAdmin
  };
}